/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-04 17:13:23
 * @LastEditors: Yi Yunwan
 * @LastEditTime: 2020-12-03 09:43:03
 */
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { baseURL, javaBaseURL } from '@/config'
import { Toast } from 'vant'
import qs from 'qs'
import { aesEncrypt, getAppLanguage, isIOS } from '@/utils'
import { CommonModule } from '@/store/modules/common'
import { callAppFunc_checkVersion } from '@/utils/bridge'

const language = getAppLanguage()
const service = axios.create({
  baseURL,
  timeout: 100000
})

service.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'

function _log(response: AxiosResponse<any>) {
  if (process.env.NODE_ENV === 'development') {
    const data = response.config.data

    if (data && JSON.stringify(data) != '"{}"') {
      Object.keys(data).length > 0 && console.log('请求参数：', data)
    }
  }
}

export function addSign(config: AxiosRequestConfig) {
  const timestamp = Math.floor(new Date().getTime() / 1000)

  config.headers['timestamp'] = timestamp
  //config.headers['sign'] = sign
  config.headers['app-version'] = CommonModule.appVersion
  config.headers['device-id'] = CommonModule.deviceId
  config.headers['request-from'] = CommonModule.requestFrom
  if (!config.headers['app-front']) {
    config.headers['app-front'] = 1
  }
  config.headers['channel'] = CommonModule.channel
  //config.headers['platform'] = isIOS ? 'ios' : 'android'
  const encryp = aesEncrypt(
    config.data ? config.data : config.params ? config.params : {}
  )
  config.headers['sign'] = encryp.toString()
  config.headers['language'] = language == 'uyghur' ? 'ug' : 'cn'
  return config
}

export function addJavaSign(config: AxiosRequestConfig) {
  const timestamp = Math.floor(new Date().getTime() / 1000)

  config.headers['timestamp'] = timestamp
  //config.headers['sign'] = sign
  config.headers['app-version'] = config.headers['app-version']
    ? config.headers['app-version']
    : CommonModule.appVersion
  config.headers['device-id'] = CommonModule.deviceId
  config.headers['request-from'] = CommonModule.requestFrom
  if (!config.headers['app-front']) {
    config.headers['app-front'] = 1
  }
  config.headers['channel'] = config.headers['channel']
    ? config.headers['channel']
    : CommonModule.channel
  config.headers['platform'] = config.headers['platform']
    ? config.headers['platform']
    : isIOS
    ? 'ios'
    : 'android'
  const encryp = aesEncrypt(
    config.data ? config.data : config.params ? config.params : {}
  )
  config.headers['sign'] = encryp.toString()
  config.headers['language'] = language == 'uyghur' ? 'ug' : 'cn'
  return config
}

export function serviceFulfilled(response: AxiosResponse) {
  // _log(response)
  // 对响应数据做点什么
  const data = response.data as IResponse
  if (response.status === 200) {
    if (data.code == '200') {
      return response.data
    } else if (data.code == '100003') {
      Toast(data.msg)
    } else if (data.code == '6001') {
      console.log('code 6001')
      callAppFunc_checkVersion(data.data)
    } else if (data.code && data.code != '1001') {
      Toast(data.msg || '服务器异常')
    }
    if (!data.code) {
      return response.data
    }
    return Promise.reject(data)
  } else {
    return Promise.reject(response)
  }
}

export function serviceRejected(error: Error) {
  // 对响应错误做点什么
  console.error(error)
  const errText =
    language == 'zh_CN' ? '网络请求失败，请重试' : 'tor ulanmidi， kayta sinag'
  error.message &&
    Toast(error.message == 'Network Error' ? errText : error.message)
  return Promise.reject(error)
}
function addAuthorization(config: AxiosRequestConfig) {
  const Authorization = CommonModule.token
  Authorization && (config.headers['Authorization'] = Authorization)
  config.headers['flavors'] = CommonModule.flavors
  return config
}

service.interceptors.request.use(addAuthorization)
service.interceptors.request.use(addSign)

service.interceptors.response.use(serviceFulfilled, serviceRejected)

const javaService = axios.create({
  baseURL: javaBaseURL,
  timeout: 60 * 1000
})
javaService.interceptors.request.use(addJavaSign)
javaService.interceptors.request.use(addAuthorization)
javaService.interceptors.response.use(serviceFulfilled, serviceRejected)
export { service, javaService }
